var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHammer = function SvgHammer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hammer_svg__Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".hammer_svg__st0{fill:none;stroke:#000;stroke-width:1.5;stroke-miterlimit:10}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hammer_svg__st0",
    d: "m20.3 1.8-2.8 2.6c-.1.1-.1.3 0 .4l.9.9-6.6 6.1-.9-.9c-.1-.1-.3-.1-.4 0l-2.8 2.6c-.1.1-.1.3 0 .4l6.9 7.4c.1.1.3.1.4 0l2.8-2.6c.1-.1.1-.3 0-.4l-.8-.9 2.1-2 9.3 10c.1.1.3.1.4 0l1.9-1.7c.1-.1.1-.3 0-.4l-9.3-10 2.1-2 .9.9c.1.1.3.1.4 0l2.8-2.6c.1-.1.1-.3 0-.4l-6.9-7.4c-.1-.1-.3-.1-.4 0zM20.8 26.9h-2.6v-2.5c0-.2-.2-.4-.4-.4H4.5c-.2 0-.4.2-.4.4v2.5H1.6c-.2 0-.4.2-.4.4V30c0 .2.2.4.4.4h19.2c.2 0 .4-.2.4-.4v-2.7c-.1-.2-.2-.4-.4-.4z"
  })));
};
export default SvgHammer;